import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import Login from './pages/Login';

const PrivateRoute = ({ children }) => {
  const { staff, signingIn } = useAuth();
  // Back from Google with a login code: stay put until it has been exchanged
  if (signingIn) {
    return <div style={{ padding: '40px', textAlign: 'center', color: '#999', fontSize: '14px' }}>Signing you in...</div>;
  }
  return staff ? children : <Navigate to="/login" />;
};

export default function App({ loginRedirect }) {
  return (
    <AuthProvider loginRedirect={loginRedirect}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
